import { Grid, Paper, Button } from "@mui/material";
import DynamicForm from "shared/organisms/dynamicform";
import useReactHookForm from "hooks/useReactHookForm";
import ContentRight from "shared/molecules/content-right";
import { hasAtLeastOneValue, nl3LiveclassMasterInitialValues, nl3LiveclassMasterProperties, nl3LiveclassMasterValidationSchema } from "./helper";
import { GET_NLEARN3_LIVECLASS_PACKAGES } from "utils/graphql/services/live-classes/queries";
import liveClassClientService from "utils/graphql/liveclassClient";
import { useAppDispatch } from "hooks/redux";
import { useEffect } from "react";
import { useLazyQuery } from "@apollo/client";
import { metadataUpdate } from "app-component/slices/metadata-slice";

export function Nl3LiveclassMasterFilter({ setSearchPayload,
  setPage,
}) {

    const { control, errors, getValues, watch, setValue } = useReactHookForm(
        nl3LiveclassMasterInitialValues,
        nl3LiveclassMasterValidationSchema,
        "",
    );
   
    const [getNlearn3LiveclassPackages] = useLazyQuery(GET_NLEARN3_LIVECLASS_PACKAGES, {
    client: liveClassClientService,
    fetchPolicy: "no-cache",
    });

    const dispatch = useAppDispatch();
  
      useEffect(() => {
        (async () => {
          try {
            const { data } = await getNlearn3LiveclassPackages({
              variables: {
                input: {
                  limit: 50,
                  offset: 0,
                },
              },
            });
    
            const Packages =
              data?.getNlearn3LiveclassPackages?.nlearn3LiveclassPackages || [];
    
            const PackagesWithCount = Packages.map((item) => ({
              ...item,
              nameWithCount: `${item.name} - ${item.packageStudentsCount}`,
            }));
    
            dispatch(
              metadataUpdate({
                key: "nl3_liveclass_packages_gq",
                value: PackagesWithCount,
              })
            );
    
            setValue("nlearn3LiveclassPackageIds", []);
          } catch (error) {
            console.error("Error fetching Nl3 Liveclass Packages:", error);
          }
        })();
      }, []);
    
  const handleSearch = () => {
  
    const payload: any = {};
    const values = watch();

    if(values.admissionNumber) payload.admissionNumber = values.admissionNumber;
    
    if (values.nlearn3LiveclassPackageIds?.length > 0) payload.nlearn3LiveclassPackageIds = values.nlearn3LiveclassPackageIds;

    if (values.markAsDeleted === "true") payload.markAsDeleted = true;
    else if (values.markAsDeleted === "false") payload.markAsDeleted = false;
    
    setSearchPayload(payload);
    setPage(1);
  }

  const clearFilter = () => {
    setValue("admissionNumber", "");
    setValue("nlearn3LiveclassPackageIds", "");
    setValue("markAsDeleted", "");
    setSearchPayload({});
    setPage(1);
  }

  return (
    <div>
      <Paper elevation={2} sx={{ px: 2, pb: 3, pt: 3 }}>
        <Grid container spacing={2}>
          <DynamicForm
            fields={nl3LiveclassMasterProperties}
            control={control}
            errors={errors}
            watch={watch}
            setValue={setValue}
            getValues={getValues}
          />

          <ContentRight sx={{ mt: -7 }}>
            <Button
              variant="contained"
              sx={{
                width: "70px",
                height: "40px",
                marginTop: "15px",
                marginRight: "10px",
                padding: "7px 42.5px 7px 48.5px",
                cursor: "pointer",
                textAlign: "center",
              }}
              onClick={clearFilter}
              disabled={!hasAtLeastOneValue(watch(), ["admissionNumber", "nlearn3LiveclassPackageIds","markAsDeleted"]) || Object.keys(errors).length > 0}
            >
              clear
            </Button>
            <Button
              variant="contained"
              sx={{
                width: "80px",
                height: "40px",
                marginTop: "15px",
                padding: "7px 42.5px 7px 48.5px",
                cursor: "pointer",
                textAlign: "center",
              }}
              onClick={handleSearch}
              disabled={!hasAtLeastOneValue(watch(), ["admissionNumber", "nlearn3LiveclassPackageIds", "markAsDeleted"]) || Object.keys(errors).length > 0}
            >
              search
            </Button>
          </ContentRight>
        </Grid>
      </Paper>
    </div>
  );
}
